var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "input_delivery" } },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("dd-sitemap", {
        attrs: { pageKey: _vm.pageKey, pageList: _vm.topForm.pageList }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("section", [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input_list" },
            [
              _c("dd-business-input", {
                ref: "businessInputRef",
                attrs: { label: _vm.label, form: _vm.form }
              }),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.label.contactFlag))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "important small_text" }, [
                      _vm._v("必須")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.contactFlag,
                          expression: "form.contactFlag"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        id: "contact_1",
                        name: "contact"
                      },
                      domProps: {
                        value: 1,
                        checked: _vm._q(_vm.form.contactFlag, 1)
                      },
                      on: {
                        change: function($event) {
                          _vm.$set(_vm.form, "contactFlag", 1)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "radio-label bold",
                        attrs: { for: "contact_1" }
                      },
                      [_vm._v("あり")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.contactFlag,
                          expression: "form.contactFlag"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        id: "contact_2",
                        name: "contact"
                      },
                      domProps: {
                        value: 0,
                        checked: _vm._q(_vm.form.contactFlag, 0)
                      },
                      on: {
                        change: function($event) {
                          _vm.$set(_vm.form, "contactFlag", 0)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "radio-label bold",
                        attrs: { for: "contact_2" }
                      },
                      [_vm._v("なし")]
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          Object.keys(_vm.errors).length > 0
            ? _c("div", { staticClass: "error_text" }, [
                _vm._v(
                  "入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "control_btn_area" }, [
            _c(
              "div",
              {
                staticClass: "detail_btn2",
                on: {
                  click: function($event) {
                    _vm.prev()
                  }
                }
              },
              [_vm._v("〈〈   戻る   ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: { detail_btn: true, disabled: !_vm.isConfirm },
                on: {
                  click: function($event) {
                    _vm.confirm()
                  }
                }
              },
              [_vm._v("現場調査情報入力")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h1", [_vm._v("事前現場調査先入力画面")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-111b990d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-111b990d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcBuildingResearchBusiness.vue
// module id = null
// module chunks = 